import { getToken, instance } from './config';

const getCustomInstances = (projectId) =>
  instance.get(`/projects/${projectId}/custom-instance-sets`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

const getCustomInstance = (projectId, instanceId) =>
  instance.get(`/projects/${projectId}/custom-instance-sets/${instanceId}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

const updateCustomInstance = (projectId, instanceId, payload) =>
  instance.put(
    `/projects/${projectId}/custom-instance-sets/${instanceId}`,
    payload,
    {
      headers: { Authorization: `Bearer ${getToken()}` },
    }
  );

const deleteCustomInstance = (projectId, instanceId) =>
  instance.delete(`projects/${projectId}/custom-instance-sets/${instanceId}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

export const customInstanceApis = {
  getCustomInstances,
  getCustomInstance,
  updateCustomInstance,
  deleteCustomInstance,
};
